<template>
  <modal
    ref="modal"
    bgcolor="rgba(0, 0, 0, .3)"
    @closed="onClosed"
  >
    <div
      ref="wrap"
      class="modal-calendar"
    >
      <div class="modal-inner">
        <i
          class="isif isif-close"
          @click="hide"
        />
        <div
          ref="header"
          class="header"
        >
          <div
            v-show="currentStep.back"
            class="back"
            @click="stepBack"
          >
            <i class="isif isif-arrow-left" />
            <span>{{ currentStep.back }}</span>
          </div>
          <div class="title">
            <div
              v-show="currentStep.headline"
              class="headline"
            >
              {{ currentStep.headline }}
            </div>
            <div
              v-if="currentStep.description"
              class="description"
            >
              {{ currentStep.description }}
            </div>
          </div>
        </div>
        <div
          ref="content"
          class="content"
          :class="{ 'no-scroll': currentStep.noScroll }"
        >
          <transition :name="contentTransition">
            <keep-alive include="BookingStep1">
              <component
                :is="currentStep.component"
                :key="step"
                class="step"
                v-bind="currentStep.props"
                @prev="stepBack"
                @next="stepNext"
              />
            </keep-alive>
          </transition>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/IModal'
import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'

export default {
  name: 'ModalBooking',
  components: {
    Modal,
    Step1,
    Step2,
    Step3
  },
  props: {
    company: {
      type: String,
      default: ''
    },
    calendar: {
      type: Boolean,
      default: false
    },
    bookings: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    step: 1,
    contentTransition: '',
    payload: {}
  }),
  computed: {
    steps () {
      return [
        {
          headline: this.company,
          description: this.$t('booking.dateSelectTitle'),
          back: '',
          noScroll: true,
          component: Step1,
          props: {
            calendar: this.calendar,
            bookings: this.bookings
          }
        },
        {
          headline: this.$t('booking.confirm'),
          description: '',
          back: this.$t('booking.backToSelect'),
          noScroll: false,
          component: Step2,
          props: {
            bookings: this.bookings,
            date: this.payload.date
          }
        },
        {
          headline: '',
          description: '',
          back: '',
          noScroll: false,
          component: Step3,
          props: {
            bookings: this.bookings,
            details: this.payload.details,
            name: this.payload.name,
            email: this.payload.email
          }
        }
      ]
    },
    currentStep () {
      return this.steps[this.step - 1]
    }
  },
  watch: {
    step (val, oldVal) {
      this.contentTransition = val > oldVal ? 'slide-left' : 'slide-right'
    }
  },
  methods: {
    show () {
      this.contentTransition = ''
      this.$refs.modal.show()
      this.$store.dispatch('setCalendarActive', true)
    },
    hide () {
      this.$refs.modal.hide()
    },
    onClosed () {
      this.$store.dispatch('setCalendarActive', false)
      this.step = 1
    },
    stepNext (payload) {
      const step = this.step + 1
      this.step = Math.min(this.steps.length, step)
      this.payload = payload
    },
    stepBack () {
      const step = this.step - 1
      this.step = Math.max(step, 1)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main'

.modal-calendar {
  width: 800px
  height: 660px
  max-width: 95vw
  max-height: 95vh
  background: #FFF
  font-size: 16px
}

.modal-inner {
  position: relative
  height: 100%
  padding: 20px 10px
  display: flex
  flex-direction: column

  @media (min-width: $response) {
    padding: 30px 20px
  }

  .isif-close {
    position: absolute
    top: 1rem
    right: 1rem
    padding: 0.75rem
    font-size: 1.5em
    color: #212121
    cursor: pointer
    z-index: 1
  }

  .header {
    position: relative
    display: flex
    justify-content: center
    text-align: center
    color: #212121
    margin-bottom: 30px
    min-height: 40px

    .back {
      position: absolute
      top: 0
      left: 0
      display: flex
      align-items: center
      height: 40px
      cursor: pointer

      i {
        margin-right: 8px
      }
      span {
        display: none
        color: inherit
        font-size: 14px
        text-shadow: none

        @media (min-width: $response) {
          display: block
        }
      }
    }
    .title {
      display: flex
      flex-direction: column
      justify-content: center
    }
    .headline {
      font-weight: bold
    }
    .description {
      color: #919191
      font-size: 14px
      margin-top: 10px
    }
  }

  .content {
    position: relative
    height: 100%
    overflow: auto

    &.no-scroll {
      overflow: hidden
    }
    .step {
      position: absolute
      width: 100%
      height: 100%
      padding: 0 5px // for spacing between slides
    }
  }
}

.slide-left-enter-active,
.slide-right-enter-active,
.slide-left-leave-active,
.slide-right-leave-active {
  transition: all .5s ease
}
.slide-left-enter,
.slide-right-leave-to {
  transform: translateX(100%)
}
.slide-left-enter-to,
.slide-right-enter-to {
  transform: translateX(0%)
}
.slide-left-leave-to,
.slide-right-enter {
  transform: translateX(-100%)
}
</style>
